import { API_ERROR_CODES, ONBOARDING_API_BASE_URL } from "./index.ts";

/**
 * Once a user is authenticated get a one time token to provide to PegaLoader
 */

type ApiGetOneTimeTokenResult = {
  data?: {
    oneTimeToken: string;
    identityId?: string; 
    owner?: string;      
    userId?: string;    
  };
  errorCode?: API_ERROR_CODES;
  errorMessage?: string;
};

export const apiGetOneTimeToken = async (
  csrfToken: string,
): Promise<ApiGetOneTimeTokenResult> => {
  return fetch(`${ONBOARDING_API_BASE_URL}/auth/one-time-token`, {
    method: "POST",
    body: JSON.stringify({}),
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "X-CSRF-Token": csrfToken,
    },
  })
    .then(async (response) => {
      if (!response.ok) {
        const errorMessage = await response.text();
        return {
          errorCode: API_ERROR_CODES.GENERIC,
          errorMessage,
        };
      }

      const responseJson = await response.json();

      return { data: responseJson } as ApiGetOneTimeTokenResult;
    })
    .catch(() => {
      return {
        errorCode: API_ERROR_CODES.GENERIC,
      };
    });
};
